<template>
  <el-dialog
    v-loading="loading"
    :title="title"
    :visible="true"
    width="700px"
    @close="$router.replace('/docket/document-types')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="documentType"
      :rules="rules"
      ref="carForm"
      label-position="top"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="name"
        label="Név"
      >
        <el-input
          v-model="documentType.name"
        />
      </el-form-item>
    </el-form>
    <h4>Extra mezők</h4>
    <el-table
      :data="documentType.extra_fields"
      border
    >
      <el-table-column
        label="Név"
        prop="name"
      >
        <template slot-scope="scope">
          <el-input
            type="text"
            v-model="documentType.extra_fields[scope.$index].name"
            size="small"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="Típus"
        prop="type"
        width="150"
      >
        <template slot-scope="scope">
          <el-select
            v-model="documentType.extra_fields[scope.$index].type"
            size="small"
          >
            <el-option
              value="text"
              label="Szöveg">Szöveg
            </el-option>
            <el-option
              value="number"
              label="Egész szám">Egész szám
            </el-option>
            <el-option
              value="date"
              label="Dátum">Dátum
            </el-option>
            <el-option
              value="currency"
              label="Deviza">Deviza
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="Kötelező"
        prop="is_required"
        width="85"
      >
        <template slot-scope="scope">
          <el-checkbox
            v-model="documentType.extra_fields[scope.$index].is_required"
          />
        </template>
      </el-table-column>
      <el-table-column
        width="70"
      >
        <template slot-scope="scope">
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            @click="deleteField(scope.$index)"
          />
        </template>
      </el-table-column>
    </el-table>
    <div
      class="add-item"
    >
      <el-button
        icon="el-icon-plus"
        size="mini"
        @click="addField"
      >
        Mező hozzáadása
      </el-button>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/docket/document-types')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ['type', 'documentTypeId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        documentType: {
          extra_fields: []
        },
        rules: {
          name: [
            { required: true, message: 'Név megadása kötelező', trigger: 'change' }
          ],
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új Irattípus';
        } else if (this.type === 'update') {
          return 'Irattípus módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    async mounted() {
      this.loading = true;
      if (this.documentTypeId) {
        this.documentType = await this.$store.dispatch('documentType/fetch', this.documentTypeId);
      }
      this.loading = false;
    },
    methods: {
      async add() {
        if(this.hasTableEmptyField()) {
          return this.$messageWrapper.warning('Mezők kitöltese kötelező')
        }
        this.$refs['carForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('documentType/create', this.documentType);
              } else if (this.type === 'update') {
                await this.$store.dispatch('documentType/update', this.documentType);
              }
              this.$store.dispatch('documentType/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/docket/document-types');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      },
      addField() {
        this.documentType.extra_fields.push({
          name: '',
          type: 'text',
          is_required: false,
        })
      },
      deleteField(index) {
        this.documentType.extra_fields.splice(index, 1);
      },
      hasTableEmptyField() {
        let hasEmptyField = false;
        for( const field of this.documentType.extra_fields) {
          if(!field.name || !field.type) {
            hasEmptyField = true;
            break;
          }
        }
        return hasEmptyField;
      }
    },
  };
</script>
<style scoped>
  .add-item {
    border-bottom: 1px dotted #dadfe7;
    border-left: 1px dotted #dadfe7;
    border-right: 1px dotted #dadfe7;
    text-align: center;
    padding: 10px;
  }
</style>
